export const INLINE_LOCATION_LIMIT = 3;

type SplitLocationsForDisplayArgs<T> = {
	locations: T[];
	limit?: number;
};

type SplitLocationsForDisplayResult<T> = {
	ordered: T[];
	visible: T[];
	hiddenCount: number;
};

export const splitLocationsForDisplay = <T extends { order: number; capacity?: "full" | "not-full" }>({
	locations,
	limit = INLINE_LOCATION_LIMIT,
}: SplitLocationsForDisplayArgs<T>): SplitLocationsForDisplayResult<T> => {
	const notFullLocations = locations
		.filter((location) => location.capacity !== "full")
		.sort((a, b) => a.order - b.order);
	const fullLocations = locations
		.filter((location) => location.capacity === "full")
		.sort((a, b) => a.order - b.order);
	const ordered = [...notFullLocations, ...fullLocations];
	const visible = ordered.slice(0, limit);
	return { ordered, visible, hiddenCount: ordered.length - visible.length };
};
